import { Injectable } from '@angular/core';

// Define a type for theme variables
type ThemeVariables = {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  primaryHover: string;
};

@Injectable({
  providedIn: 'root'
})
export class CcsThemeService {
  // Theme variables based on the style guide
  themeVariables: ThemeVariables = {
    primary: '#007991',
    primaryDark: '#2E4A66',
    primaryLight: '#e6f7fa',
    primaryHover: '#029bb9'
  };

  constructor() {
    // Set CSS variables in the document root
    this.applyThemeVariables();
  }

  // Apply theme variables to the document root as CSS variables
  private applyThemeVariables(): void {
    const root = document.documentElement;
    
    for (const [key, value] of Object.entries(this.themeVariables)) {
      // Convert camelCase to kebab-case for CSS variables
      const cssVarName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      root.style.setProperty(`--${cssVarName}`, value);
    }
  }

  // Get a theme variable value
  getThemeVariable(name: keyof ThemeVariables): string {
    return this.themeVariables[name];
  }
}
